export default {
    addSpecialWorkday: 'เพิ่มวันทำงานพิเศษ',
    editSpecialWorkday: 'แก้ไขวันทำงานพิเศษ',
    specialWorkdayName: 'ชื่อวันทำงานพิเศษ',
    forGroup: 'สำหรับกลุ่ม',
    workday: 'วันทำงาน',
    checkinTime: 'เวลาเริ่มเช็คอิน',
    startTime: 'เวลาเข้างาน',
    breakTime: 'ชั่วโมงการพัก',
    endTime: 'เวลาออกงาน',
    description: 'คำอธิบาย',
    save: 'บันทึก',
    msgError: 'เกิดข้อผิดพลาด',
    congratulation: 'ยินดีด้วย',
    msgErrorStartTimeAndEndTime: 'วันที่ถูกสร้างควรจะน้อยกว่าวันที่สิ้นสุด',
    msgCreateSuccess: 'วันทำงานพิเศษถูกสร้างแล้ว',
    msgUpdateSuccess: 'วันทำงานพิเศษถูกอัปเดตแล้ว',
    msgRequiredField: 'กรุณากรอกข้อมูล',
    msgLimitCharacters: 'ช่องนี้รองรับตัวอักษรไม่เกิน 255 ตัวอักษร'
}
